// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7c15de80","239":"a7751f7e","455":"94c8f55f"}[chunkId] + ".chunk.js";
};